import { pushVideoEvent, VIDEO } from "./events";

//Add pause events for autoplay carousels for dam/bc
export function setPauseButton(videoDiv) {
  let carousel = videoDiv.closest(".carousel__wrap");
  if (carousel) {
      if (carousel.getAttribute("data-autoplay") === "true") {
          videoDiv.addEventListener("click", function () {
              let carouselId = carousel.dataset.uuid;
              let pauseBtnParent = document.querySelector(`[data-uuid="${carouselId}"]`);
              let pauseBtn = pauseBtnParent.querySelector(".carousel__autoplayBtn");
              let action = pauseBtn.getAttribute("data-action");
              if (pauseBtn && action === "stop") {
                  pauseBtn.click();
              }
          });
      }
  }
}

// html5
export function damPlayer(damVideo) {
    let title = damVideo.dataset?.title;
    let context = damVideo.dataset?.gtmcontext;
    let eventsPushed = {};

    setPauseButton(damVideo.parentElement);

    damVideo.addEventListener("loadedmetadata", function (e) {
        if (damVideo.closest(".tns-slide-cloned")) { // to avoid duplicate "view" push, due to carousel cloning of slides
            eventsPushed[VIDEO.view] = true;
        } else {
            if (!eventsPushed[VIDEO.view]) {
                pushVideoEvent({
                    event: VIDEO.view,
                    video_duration: e.target.duration,
                    video_percent: "0%",
                    video_provider: "dam",
                });
                eventsPushed[VIDEO.view] = true;
            }
        }
    });

    if (!eventsPushed[VIDEO.view]) {
        damVideo.load();
    }

    damVideo.addEventListener("pause", function (e) {
        const currentTime = e.target.currentTime;
        const duration = e.target.duration;
        const pct = Math.floor((currentTime / duration) * 100);
        pushVideoEvent({
            event: VIDEO.progress(pct),
            video_duration: duration,
            video_percent: `${pct}%`,
            video_provider: "dam",
        });
    });

    damVideo.addEventListener("timeupdate", function (e) {
        if (e.target.currentTime < 0.5 && eventsPushed[100]) {
            eventsPushed[100] = false;
        }
        if (!eventsPushed[VIDEO.start] && !isNaN(e.target.duration)) {
            pushVideoEvent({
                event: VIDEO.start,
                video_duration: e.target.duration,
                video_percent: "0%",
                video_provider: "dam",
            });
            eventsPushed[VIDEO.start] = true;
        }

        //since looped videos don't end, this just emulates the 'ended' event firing
        let pctFloor = Math.floor((e.target.currentTime / e.target.duration) * 100);
        const milestones = [40, 80, 100];

        milestones.forEach(m => {
            const key = `progress_${m}`;
            if (pctFloor >= m && !eventsPushed[key]) {
                eventsPushed[key] = true;
                pushVideoEvent({
                    event: VIDEO.progress(m),
                    video_duration: e.target.duration,
                    video_percent: `${m}%`,
                    video_provider: "dam",
                });
            }
        });

        if (e.target.loop === true && pctFloor > 90 && !eventsPushed[100]) {
            eventsPushed[100] = true;

            pushVideoEvent({
                event: VIDEO.finish,
                video_duration: e.target.duration,
                video_percent: "100%",
                video_provider: "dam",
            });
        }
    });

    // Ended
    damVideo.addEventListener("ended", function (e) {
        eventsPushed = {};
        pushVideoEvent({
            event: VIDEO.finish,
            video_duration: e.target.duration,
            video_percent: "100%",
            video_provider: "dam",
        });
    });

    // Error
    damVideo.addEventListener("error", function (e) {
        let error = e;

        // Chrome v60
        if (e.path && e.path[0]) {
            error = e.path[0].error;
        }

        // Firefox v55
        if (e.originalTarget) {
            error = error.originalTarget.error;
        }

        if (!eventsPushed[VIDEO.error]) {
            pushVideoEvent({
                event: VIDEO.error,
                video_duration: 0,
                video_percent: "0%",
                video_provider: "dam",
                error_type: error.message || "unknown error",
            });

            eventsPushed[VIDEO.error] = true;
        }
    });
}
